import * as React from 'react';
import { LessonForm as SharedLessonForm } from '../../../Shared/components/lessons/lessonForm';
import ChooseModel from './chooseModel';

export const LessonForm: React.FC<any> = (props) => (
  <SharedLessonForm
    {...props}
    ChooseModelComponent={ChooseModel}
    showELL={true}
  />
);

export default LessonForm;
